import { useTranslation } from "react-i18next";
import { answerText } from "./answerText";
import type { Answers, Template } from "./types";

/** Compact read-only list of one version's questions and the person's answers (no inputs). */
export function VersionAnswers({
  template,
  answers,
  fileName,
}: {
  template: Template;
  answers: Answers;
  fileName: (id: string) => string | undefined;
}) {
  const { t } = useTranslation();
  const labels = { yes: t("questionnaire.yes"), no: t("questionnaire.no"), fileRemoved: t("questionnaire.answers.fileRemoved") };
  const sections = template.sections
    .filter((s) => s.audience === "client")
    .map((s) => ({ ...s, questions: s.questions.filter((q) => q.type !== "info" && !q.deprecated) }))
    .filter((s) => s.questions.length > 0);
  return (
    <div className="flex flex-col gap-6">
      {sections.map((s) => (
        <section key={s.id} className="flex flex-col gap-3">
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-fg-muted">{s.title}</h4>
          <dl className="flex flex-col divide-y divide-border">
            {s.questions.map((q) => {
              const text = answerText(q, answers[q.id], fileName, labels);
              return (
                <div key={q.id} className="flex flex-col gap-1 py-3 sm:grid sm:grid-cols-2 sm:gap-6">
                  <dt className="font-medium text-heading">{q.title}</dt>
                  <dd className={text ? "whitespace-pre-wrap" : "text-fg-subtle"}>{text || t("questionnaire.answers.notAnswered")}</dd>
                </div>
              );
            })}
          </dl>
        </section>
      ))}
    </div>
  );
}
